<p-dialog header="Move Site"
          [(visible)]="showModal"
          (onHide)="closeModal()"
          [modal]="true"
          [resizable]="false"
          [contentStyle]="{ overflow: 'visible'}"
          [style]="{ width: '45rem' }">
    <p>Moving this site will need to be confirmed by both organizations' Admin.
        Once approved, all {{ enterpriseLabels.universalIdsLabel }} that are linked to this site will be recreated in the destination organization.
        Any Universal IDs that only link to the site that is moving will be disabled in the originating
        organization.</p>
    <label for="enterpriseSelection" class="fw-normal">Organization <span class="text-danger">*</span></label>
    <ng-select id="enterpriseSelection"
               data-identifier="organization-relocation-enterprise-selection"
               [(ngModel)]="selectedEnterprise"
               [items]="(enterprises | async) ?? []"
               (open)="enterpriseSearchSubject.next('')"
               (clear)="selectedEnterprise = undefined"
               [typeahead]="enterpriseSearchSubject"
               placeholder="Search">
        <ng-template ng-label-tmp let-item="item">
            <div class="row">
                <div class="col-sm-auto pe-0">{{ item.name }}</div>
                <div class="col-sm-auto ps-1 enterprise-alias-label">{{ item.alias }}{{ item.orgAdminDomain }}</div>
            </div>
        </ng-template>
        <ng-template ng-header-tmp>
            <div class="row">
                <div class="col-3">Organization</div>
                <div class="col-6">Organization Admin URL</div>
                <div class="col-1">Sites</div>
            </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
            <div data-identifier="organization-relocation-enterprise-option" class="row">
                <div class="col-3">{{ item.name }}</div>
                <div class="col-6">{{ item.alias }}{{ item.orgAdminDomain }}</div>
                <div class="col-1">{{ item.activeOrganizationsCount }}</div>
            </div>
        </ng-template>
    </ng-select>
    <hr class="mt-5">
    <div class="d-flex justify-content-end">
        <button data-identifier="organization-relocation-cancel" class="btn btn-sm btn-default me-2"
                (click)="closeModal()">Cancel
        </button>
        <button data-identifier="organization-relocation-move" class="btn btn-sm btn-primary"
                [disabled]="!selectedEnterprise" (click)="createRelocation()">Move
        </button>
    </div>
</p-dialog>
